import { Component, Input, OnInit } from '@angular/core';
import { MailSidenavLink } from '../../interfaces/mail-sidenav-link.interface';
import { MatDrawer } from '@angular/material/sidenav';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { stagger40ms } from '@vex/animations/stagger.animation';
import { fadeInUp400ms } from '@vex/animations/fade-in-up.animation';
import { MailSidenavLinkComponent } from '../mail-sidenav-link/mail-sidenav-link.component';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MailService } from '../../services/mail.service';

@Component({
    selector: 'vex-mail-sidenav',
    templateUrl: './mail-sidenav.component.html',
    styleUrls: ['./mail-sidenav.component.scss'],
    animations: [stagger40ms, fadeInUp400ms],
    imports: [NgFor, NgIf, AsyncPipe, MailSidenavLinkComponent]
})
export class MailSidenavComponent implements OnInit {
  @Input({ required: true }) drawer!: MatDrawer;

  links: MailSidenavLink[] = [
    {
      label: 'Inbox',
      route: ['INBOX'],
      icon: 'mat:inbox'
    },
    {
      label: 'Sent',
      route: ['SENT'],
      icon: 'mat:send'
    },
    {
      label: 'Drafts',
      route: ['DRAFT'],
      icon: 'mat:drafts'
    },
    {
      label: 'Trash',
      route: ['TRASH'],
      icon: 'mat:delete'
    }
  ];

  labelLinks: MailSidenavLink[] = [];

  constructor(
    private layoutService: VexLayoutService,
    public mailService: MailService
  ) {}

  ngOnInit(): void {
    this.mailService.availableLabels.subscribe((labels) => {
      this.labelLinks = [
        {
          label: 'Important',
          route: ['IMPORTANT'],
          icon: 'mat:label_important'
        },
        ...labels.map((label) => ({
          label,
          route: [label.toUpperCase()],
          icon: 'mat:label'
        }))
      ];
    });
  }

  closeDrawer() {
    if (this.layoutService.isLtLg()) {
      this.drawer?.close();
    }
  }

  selectFolder(folder: string) {
    this.mailService.selectFolder(folder);
    this.closeDrawer();
  }
}
